// TypeBlaster game configuration & word lists

const HOME = "asdfjkl;".split("");
const HOME_LETTERS = "asdfghjkl".split("");
const UP = "eiru".split("");
const MID = "gh".split("");
const TOP_STRETCH = "ty".split("");
const TOP_CORNERS = "woqp".split("");
const DOWN = "vmbn".split("");
const BOTTOM_CORNERS = "cxz".split("");

const SHORT_WORDS = [
  "cat", "dog", "sun", "hat", "run", "box", "cup", "pen", "red", "fun", "map", "bed", "toy", "car", "egg",
  "bat", "fox", "jam", "key", "owl", "ice", "snow", "fish", "lion", "bear", "frog", "duck", "cake", "ship",
  "king", "star", "moon", "wand", "hero", "sing", "jump", "dance", "laugh", "magic", "candy", "puppy",
  "robot", "queen", "sword", "pizza", "happy", "ant", "bee", "bug", "cow", "pig", "hen", "rat", "bus", "van",
  "jet", "sky", "sea", "mud", "log", "tree", "leaf", "rock", "sand", "wave", "rain", "wind", "fire", "gold",
  "ring", "bell", "drum", "book", "page", "door", "lamp", "kite", "ball", "game", "play", "race", "swim",
  "hide", "seek", "read", "draw", "bake", "cook", "milk", "corn", "soup", "rice", "bean", "pear", "plum",
  "lime", "nest", "wing", "tail", "paw", "fur", "hug", "nap", "zoo", "farm", "barn", "pond", "hill", "cave",
  "boat", "wish", "song", "joke", "gift", "crown", "brave", "smile", "giant", "fairy", "witch", "ghost",
  "troll", "sheep", "goat", "horse", "zebra", "camel", "whale", "shark", "crab", "snail", "mouse", "bunny",
];
const LONG_WORDS = [
  "planet", "rocket", "galaxy", "laser", "cosmic", "meteor", "comet", "orbit", "nebula", "gravity", "typing",
  "keyboard", "starship", "photon", "asteroid", "explorer", "voyager", "quantum", "castle", "dragon",
  "princess", "monster", "jungle", "ocean", "treasure", "pirate", "wizard", "forest", "rainbow", "balloon",
  "kitten", "dinosaur", "adventure", "friend", "island", "garden", "village", "monkey", "tiger", "penguin",
  "unicorn", "mermaid", "superhero", "butterfly", "chocolate", "kingdom", "journey", "courage", "family",
  "giggle", "snowman", "pumpkin", "elephant", "giraffe", "dolphin", "octopus", "parrot", "hamster", "rabbit",
  "turtle", "spider", "beetle", "ladybug", "firefly", "bubble", "puzzle", "picnic", "circus", "carnival",
  "popcorn", "cupcake", "cookie", "pancake", "sandwich", "banana", "cherry", "orange", "mango", "coconut",
  "bicycle", "scooter", "airplane", "submarine", "tractor", "robot", "blanket", "pillow", "lantern",
  "campfire", "mountain", "volcano", "desert", "glacier", "meadow", "river", "waterfall", "thunder",
  "lightning", "sunshine", "moonlight", "twilight", "sparkle", "glitter", "whisper", "wonder", "secret",
  "mystery", "promise", "surprise", "birthday", "holiday", "festival", "parade", "costume", "treasure",
  "compass", "telescope", "backpack", "notebook", "crayon", "painting", "library", "science", "history",
  "teacher", "pupil", "homework", "playground", "swing", "slide", "sandbox", "seesaw", "trampoline",
];
const LETTERS = "abcdefghijklmnopqrstuvwxyz".split("");
const DIGITS = "1234567890".split("");
const SYMBOL_KEYS = "!@#$%&*?-=+".split("");
const EVERYTHING = [...LETTERS, ...DIGITS, ...SYMBOL_KEYS];

// most common English bigrams with their natural frequencies (%)
const BIGRAMS = [
  ["th", 3.56], ["he", 3.07], ["in", 2.43], ["er", 2.05], ["an", 1.99], ["re", 1.85], ["on", 1.76],
  ["at", 1.49], ["en", 1.45], ["nd", 1.35], ["ti", 1.34], ["es", 1.34], ["or", 1.28], ["te", 1.2],
  ["of", 1.17], ["ed", 1.17], ["is", 1.13], ["it", 1.12], ["al", 1.09], ["ar", 1.07], ["st", 1.05],
  ["to", 1.05], ["nt", 1.04], ["ng", 0.95], ["se", 0.93], ["ha", 0.93], ["as", 0.87], ["ou", 0.87],
  ["io", 0.83], ["le", 0.83], ["ve", 0.83], ["co", 0.79], ["me", 0.79], ["de", 0.76], ["hi", 0.76],
  ["ri", 0.73], ["ro", 0.73], ["ic", 0.7], ["ne", 0.69], ["ea", 0.69], ["ra", 0.69], ["ce", 0.65],
];
const TRIGRAMS = [
  ["the", 3.5], ["and", 1.6], ["ing", 1.1], ["ion", 0.8], ["tio", 0.7], ["ent", 0.7], ["ati", 0.6], ["for", 0.6],
  ["her", 0.6], ["ter", 0.6], ["hat", 0.5], ["tha", 0.5], ["ere", 0.5], ["ate", 0.5], ["his", 0.5], ["con", 0.5],
  ["res", 0.5], ["ver", 0.5], ["all", 0.5], ["ons", 0.4], ["nce", 0.4], ["men", 0.4], ["ith", 0.4], ["ted", 0.4],
  ["ers", 0.4], ["pro", 0.4], ["thi", 0.4], ["wit", 0.4], ["are", 0.4], ["ess", 0.4], ["not", 0.4], ["ive", 0.4],
  ["was", 0.4], ["ect", 0.3], ["rea", 0.3], ["com", 0.3], ["eve", 0.3], ["per", 0.3], ["int", 0.3], ["est", 0.3],
  ["sta", 0.3], ["cti", 0.3], ["ica", 0.3], ["ist", 0.3], ["ear", 0.3], ["ain", 0.3], ["one", 0.3], ["our", 0.3],
];
const weightedPick = (table) => {
  const total = table.reduce((a, [, w]) => a + w, 0);
  let r = Math.random() * total;
  for (const [item, w] of table) {
    r -= w;
    if (r <= 0) return item;
  }
  return table[0][0];
};

// avoid repeating the same word within the last few spawns of a level
const recentByLevel = new Map();
const RECENT_WINDOW = 10;
const freshPick = (level, arr, exclude = new Set()) => {
  const recent = recentByLevel.get(level.id) || [];
  const banned = new Set([...recent, ...exclude]);
  const candidates = arr.filter((w) => !banned.has(w));
  const word = rand(candidates.length ? candidates : arr);
  recentByLevel.set(level.id, [...recent, word].slice(-RECENT_WINDOW));
  return word;
};

// pair from a restricted letter pool: natural bigrams when available, else a random pair
const poolPair = (pool) => {
  const allowed = new Set(pool);
  const table = BIGRAMS.filter(([bg]) => allowed.has(bg[0]) && allowed.has(bg[1]));
  if (table.length >= 4 && Math.random() < 0.7) return weightedPick(table);
  const a = rand(pool);
  let b = rand(pool);
  while (b === a) b = rand(pool);
  return a + b;
};

const BIGRAM_TOTAL = BIGRAMS.reduce((a, [, w]) => a + w, 0);
const weightedBigram = () => {
  let r = Math.random() * BIGRAM_TOTAL;
  for (const [bg, w] of BIGRAMS) {
    r -= w;
    if (r <= 0) return bg;
  }
  return BIGRAMS[0][0];
};

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
const uniq = (arr) => [...new Set(arr)];
const capFirst = (w) => w[0].toUpperCase() + w.slice(1);

// weighted generator: `newWeight` share of aliens use the level's new keys, rest review older keys
export function generateLabel(level, onScreen = []) {
  const { gen, pool = [], newKeys = [], newWeight = 0.6, comboChance = 0, comboLen = 2, capsChance = 0, capitalize = false, bigrams = false, trigrams = false } = level;
  if (bigrams) return Math.random() < comboChance ? weightedBigram() : rand(pool);
  if (level.pairs) return Math.random() < comboChance ? poolPair(pool) : rand(pool);
  if (trigrams) return Math.random() < comboChance ? weightedPick(TRIGRAMS) : weightedBigram();
  if (gen === "short" || gen === "long") {
    const exclude = new Set(onScreen.map((w) => w.toLowerCase()));
    const w = freshPick(level, gen === "short" ? SHORT_WORDS : LONG_WORDS, exclude);
    return capitalize ? capFirst(w) : w;
  }
  const review = pool.filter((k) => !newKeys.includes(k));
  const pick = () => {
    let c = review.length && Math.random() >= newWeight ? rand(review) : rand(newKeys.length ? newKeys : pool);
    if (capsChance && /[a-z]/.test(c) && Math.random() < capsChance) c = c.toUpperCase();
    return c;
  };
  if (comboChance && Math.random() < comboChance) {
    let out = "";
    let prev = null;
    for (let i = 0; i < comboLen; i++) {
      let c = pick();
      while (c === prev) c = pick();
      out += c;
      prev = c;
    }
    return out;
  }
  return pick();
}

const HOME_REMINDER = ""; // the home-row reminder is shown as a footer on every intro card (Overlays.jsx)

const letterLevel = (o) => ({
  quota: 10,
  maxAliens: 4,
  newWeight: 0.6,
  outlineKeys: HOME,
  ...o,
});

export const MULTI_CHAR_BATCH_PAUSE = 6000;
export const MULTI_CHAR_SLOWDOWN = 0.9;

// levels whose labels are 2+ characters (pairs, trigrams, words, combos)
export const isMultiChar = (lv) => Boolean(lv.pairs || lv.bigrams || lv.trigrams || lv.gen || lv.comboChance > 0);

export const LEVELS = [
  letterLevel({
    id: 1,
    name: "F D J K",
    focus: "Index & middle fingers rest on F D J K",
    intro: "The HOME ROW is the middle row of letters (outlined in white). Your fingers always rest there. Feel the bumps on F and J!",
    newKeys: "fdjk".split(""),
    pool: "fdjk".split(""),
    hint: "Type the letter, then press SPACE",
    quota: 8,
    speed: 0.05,
    spawnInterval: 2500,
    bossSpeed: 0.016,
    bossTokens: ["f", "j", "d", "k", "f", "j"],
  }),
  letterLevel({
    id: 2,
    name: "HOME ROW",
    focus: "Whole home row: A S D F  J K L ;",
    intro: "Keep your index and middle fingers on F D J K as before — feel the bumps on F and J! Now the ring and pinky fingers join in on A S and L ;.",
    newKeys: "asl;".split(""),
    pool: HOME,
    hint: "Home row letters, then SPACE",
    speed: 0.06,
    spawnInterval: 2200,
    bossSpeed: 0.018,
    bossTokens: ["a", "s", "d", "f", "j", "k", "l", ";"],
  }),
  letterLevel({
    id: 3,
    name: "REACH UP · E I R U",
    focus: "Middle fingers reach up to E and I · index fingers reach up to R and U",
    intro: HOME_REMINDER + " Only home row letters plus E I R U appear here.",
    newKeys: UP,
    pool: [...HOME, ...UP],
    hint: "Home row + E I R U",
    speed: 0.065,
    spawnInterval: 2100,
    bossSpeed: 0.019,
    bossTokens: ["e", "i", "r", "u", "d", "k", "e", "i"],
  }),
  letterLevel({
    id: 4,
    name: "THE MIDDLE · G H",
    focus: "Index fingers slide sideways to G (left) and H (right)",
    intro: HOME_REMINDER + " Only home row letters plus G and H this time — practise the sideways slide.",
    newKeys: MID,
    pool: [...HOME, ...MID],
    hint: "Home row + G H",
    speed: 0.065,
    spawnInterval: 2100,
    bossSpeed: 0.019,
    bossTokens: ["g", "h", "f", "j", "g", "h"],
  }),
  letterLevel({
    id: 5,
    name: "MIX · UP + MIDDLE",
    focus: "Home row + E I R U + G H all together",
    intro: HOME_REMINDER + " Everything you know so far is mixed in: middle fingers up to E I, index fingers up to R U and sideways to G H.",
    newKeys: [...MID, ...UP],
    newWeight: 0.5,
    pool: [...HOME, ...UP, ...MID],
    hint: "Home row + E I R U + G H",
    quota: 12,
    maxAliens: 5,
    speed: 0.07,
    spawnInterval: 1900,
    bossSpeed: 0.02,
    bossTokens: ["g", "e", "h", "i", "r", "u", "g", "h"],
  }),
  letterLevel({
    id: 6,
    name: "TOP STRETCH · T Y",
    focus: "Index fingers stretch up and inwards to T (left) and Y (right)",
    intro: HOME_REMINDER + " Only home row letters plus T and Y — the longest reach for your index fingers.",
    newKeys: TOP_STRETCH,
    pool: [...HOME, ...TOP_STRETCH],
    hint: "Home row + T Y",
    speed: 0.07,
    spawnInterval: 2000,
    bossSpeed: 0.02,
    bossTokens: ["t", "y", "f", "j", "t", "y"],
  }),
  letterLevel({
    id: 7,
    name: "MIX · ALL SO FAR",
    focus: "Home row + E I R U + G H + T Y",
    intro: HOME_REMINDER + " All the index and middle finger reaches are mixed together now.",
    newKeys: TOP_STRETCH,
    newWeight: 0.4,
    pool: [...HOME, ...UP, ...MID, ...TOP_STRETCH],
    hint: "Everything you've learned so far",
    quota: 12,
    maxAliens: 5,
    speed: 0.075,
    spawnInterval: 1800,
    bossSpeed: 0.021,
    bossTokens: ["t", "e", "y", "i", "g", "r", "h", "u"],
  }),
  letterLevel({
    id: 8,
    name: "TOP CORNERS · W O Q P",
    focus: "Ring fingers reach up to W and O · pinkies reach up to Q and P",
    intro: HOME_REMINDER + " Only home row letters plus W O Q P — small fingers, big reach!",
    newKeys: TOP_CORNERS,
    pool: [...HOME, ...TOP_CORNERS],
    hint: "Home row + W O Q P",
    speed: 0.07,
    spawnInterval: 2000,
    bossSpeed: 0.02,
    bossTokens: ["w", "o", "q", "p", "s", "l", "a", ";"],
  }),
  letterLevel({
    id: 9,
    name: "MIX · TOP ROW",
    focus: "Home row + the whole top row + G H",
    intro: HOME_REMINDER + " The full top row Q W E R T Y U I O P is now in play together with the home row.",
    newKeys: TOP_CORNERS,
    newWeight: 0.4,
    pool: [...HOME, ...UP, ...MID, ...TOP_STRETCH, ...TOP_CORNERS],
    hint: "Home row + top row",
    quota: 12,
    maxAliens: 5,
    speed: 0.08,
    spawnInterval: 1700,
    bossSpeed: 0.022,
    bossTokens: ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
  }),
  letterLevel({
    id: 10,
    name: "REACH DOWN · V M B N",
    focus: "Index fingers reach down to V and M, and down-inwards to B and N",
    intro: HOME_REMINDER + " Only home row letters plus V M B N — your first bottom row keys.",
    newKeys: DOWN,
    pool: [...HOME, ...DOWN],
    hint: "Home row + V M B N",
    speed: 0.07,
    spawnInterval: 2000,
    bossSpeed: 0.02,
    bossTokens: ["v", "m", "b", "n", "f", "j", "v", "m"],
  }),
  letterLevel({
    id: 11,
    name: "MIX · UP & DOWN",
    focus: "Home row + top row + V M B N",
    intro: HOME_REMINDER + " Index fingers now go up, sideways and down. Everything so far is mixed in.",
    newKeys: DOWN,
    newWeight: 0.4,
    pool: [...HOME, ...UP, ...MID, ...TOP_STRETCH, ...TOP_CORNERS, ...DOWN],
    hint: "Everything you've learned so far",
    quota: 12,
    maxAliens: 5,
    speed: 0.08,
    spawnInterval: 1700,
    bossSpeed: 0.022,
    bossTokens: ["v", "r", "m", "u", "b", "t", "n", "y"],
  }),
  letterLevel({
    id: 12,
    name: "BOTTOM CORNERS · C X Z",
    focus: "Middle finger reaches down to C · ring finger to X · pinky to Z",
    intro: HOME_REMINDER + " Only home row letters plus C X Z — the last three letters!",
    newKeys: BOTTOM_CORNERS,
    pool: [...HOME, ...BOTTOM_CORNERS],
    hint: "Home row + C X Z",
    speed: 0.07,
    spawnInterval: 2000,
    bossSpeed: 0.02,
    bossTokens: ["c", "x", "z", "d", "s", "a", "c", "x"],
  }),
  letterLevel({
    id: 13,
    name: "ALL LETTERS",
    focus: "Every letter of the alphabet",
    intro: HOME_REMINDER + " You know all 26 letters! Any of them can appear now.",
    newKeys: [],
    newWeight: 0,
    pool: LETTERS,
    hint: "Any letter can appear",
    quota: 12,
    maxAliens: 5,
    speed: 0.08,
    spawnInterval: 1800,
    bossSpeed: 0.022,
    bossTokens: ["q", "z", "x", "m", "w", "p", "v", "b"],
  }),
  letterLevel({
    id: 14,
    name: "PAIRS · HOME ROW",
    focus: "Two-letter pairs using only the home row (A S D F G H J K L)",
    intro: "Two letters at a time, all from the home row. Type both letters, then SPACE.",
    newKeys: [],
    newWeight: 0,
    pairs: true,
    comboChance: 0.6,
    pool: HOME_LETTERS,
    hint: "Letter pairs, then SPACE",
    quota: 10,
    maxAliens: 5,
    speed: 0.075,
    spawnInterval: 1900,
    bossSpeed: 0.021,
    bossTokens: ["as", "ha", "al", "sa", "la", "ad", "fa", "ga"],
  }),
  letterLevel({
    id: 15,
    name: "PAIRS · HOME + TOP",
    focus: "Pairs from the home row and the top row (no corners)",
    intro: "Pairs now reach up to E R T Y U I as well. Type both letters, then SPACE.",
    newKeys: [],
    newWeight: 0,
    pairs: true,
    comboChance: 0.6,
    pool: [...HOME_LETTERS, ...UP, ...TOP_STRETCH],
    hint: "Letter pairs, then SPACE",
    quota: 10,
    maxAliens: 5,
    speed: 0.075,
    spawnInterval: 1900,
    bossSpeed: 0.021,
    bossTokens: ["th", "he", "er", "at", "ti", "es", "te", "it"],
  }),
  letterLevel({
    id: 16,
    name: "PAIRS · HOME + BOTTOM",
    focus: "Pairs from the home row and the bottom row (no corners)",
    intro: "Pairs now reach down to V B N M as well. Type both letters, then SPACE.",
    newKeys: [],
    newWeight: 0,
    pairs: true,
    comboChance: 0.6,
    pool: [...HOME_LETTERS, ...DOWN],
    hint: "Letter pairs, then SPACE",
    quota: 10,
    maxAliens: 5,
    speed: 0.075,
    spawnInterval: 1900,
    bossSpeed: 0.021,
    bossTokens: ["an", "nd", "ha", "ma", "nb", "ba", "vs", "mn"],
  }),
  letterLevel({
    id: 17,
    name: "PAIRS · HOME + TOP + CORNERS",
    focus: "Pairs from the home row, top row and top corners (Q W O P)",
    intro: "Pairs can now use the whole top row including Q W O P. Type both letters, then SPACE.",
    newKeys: [],
    newWeight: 0,
    pairs: true,
    comboChance: 0.6,
    pool: [...HOME_LETTERS, ...UP, ...TOP_STRETCH, ...TOP_CORNERS],
    hint: "Letter pairs, then SPACE",
    quota: 10,
    maxAliens: 5,
    speed: 0.075,
    spawnInterval: 1900,
    bossSpeed: 0.021,
    bossTokens: ["th", "or", "to", "ou", "io", "ro", "pr", "wo"],
  }),
  letterLevel({
    id: 18,
    name: "LETTER PAIRS",
    focus: "Common letter pairs like TH, HE, IN, ER",
    intro: HOME_REMINDER + " Some aliens carry the two-letter pairs that appear most in real English words — type both letters, then SPACE. This is your bridge to real words.",
    newKeys: [],
    newWeight: 0,
    comboChance: 0.6,
    bigrams: true,
    pool: LETTERS,
    hint: "Letters and letter pairs",
    quota: 12,
    maxAliens: 5,
    speed: 0.08,
    spawnInterval: 1800,
    bossSpeed: 0.022,
    bossTokens: ["th", "he", "in", "er", "an", "re", "on", "at"],
  }),
  {
    id: 19,
    name: "TRIGRAMS",
    focus: "Common three-letter chunks like THE, AND, ING",
    intro: HOME_REMINDER + " These three-letter chunks appear inside thousands of English words. Type all three letters, then SPACE.",
    newKeys: [],
    newWeight: 0,
    trigrams: true,
    comboChance: 0.7,
    pool: LETTERS,
    hint: "Three-letter chunks, then SPACE",
    speed: 0.075,
    spawnInterval: 2300,
    quota: 8,
    maxAliens: 4,
    bossSpeed: 0.02,
    bossTokens: ["the", "and", "ing", "ion", "ent", "for", "her", "all"],
  },
  letterLevel({
    id: 20,
    name: "CAPITALS",
    focus: "Some letters are CAPITALS — hold SHIFT with the other hand's pinky",
    intro: HOME_REMINDER + " For a capital letter, hold SHIFT with the pinky of the OTHER hand while you press the letter. Capitals must match exactly!",
    newKeys: [],
    newWeight: 0,
    capsChance: 0.45,
    caseSensitive: true,
    pool: LETTERS,
    hint: "Capitals need SHIFT — match the case!",
    quota: 12,
    maxAliens: 5,
    speed: 0.075,
    spawnInterval: 1900,
    bossSpeed: 0.021,
    bossTokens: ["A", "s", "D", "f", "J", "k", "L", "Q"],
  }),
  {
    id: 21,
    name: "SHORT WORDS",
    focus: "Type whole 3-letter words",
    intro: HOME_REMINDER + " Type the whole word, then press SPACE to fire.",
    newKeys: [],
    gen: "short",
    hint: "Type the whole word, then SPACE",
    speed: 0.07,
    spawnInterval: 2600,
    quota: 8,
    maxAliens: 4,
    bossSpeed: 0.02,
    bossTokens: ["the", "cat", "can", "run", "fast"],
  },
  {
    id: 22,
    name: "LONGER WORDS",
    focus: "Bigger words",
    intro: HOME_REMINDER + " Longer words now. Look at the keyboard guide if you get stuck.",
    newKeys: [],
    gen: "long",
    hint: "Bigger words, same idea",
    speed: 0.065,
    spawnInterval: 3000,
    quota: 8,
    maxAliens: 4,
    bossSpeed: 0.018,
    bossTokens: ["rockets", "fly", "to", "distant", "planets"],
  },
  {
    id: 23,
    name: "CAPITALIZED WORDS",
    focus: "Short words with a capitalized first letter",
    intro: HOME_REMINDER + " Every word starts with a capital — SHIFT with the other hand's pinky for the first letter only.",
    newKeys: [],
    gen: "short",
    capitalize: true,
    caseSensitive: true,
    hint: "Capital first letter, then SPACE",
    speed: 0.07,
    spawnInterval: 2600,
    quota: 8,
    maxAliens: 4,
    bossSpeed: 0.02,
    bossTokens: ["The", "Cat", "Can", "Run", "Fast"],
  },
  {
    id: 24,
    name: "BIG CAPITALIZED WORDS",
    focus: "Long words with a capitalized first letter",
    intro: HOME_REMINDER + " Long words with a capital first letter. Take your time — accuracy beats speed.",
    newKeys: [],
    gen: "long",
    capitalize: true,
    caseSensitive: true,
    hint: "Capital first letter, long words",
    speed: 0.065,
    spawnInterval: 3000,
    quota: 8,
    maxAliens: 4,
    bossSpeed: 0.018,
    bossTokens: ["Rockets", "Fly", "To", "Distant", "Planets"],
  },
  {
    id: 25,
    name: "NUMBERS",
    focus: "The number row 1 2 3 4 5 6 7 8 9 0",
    intro: "The number row is the very top row. Reach up from the home row with the same finger that owns the column, then come back down.",
    newKeys: DIGITS,
    pool: DIGITS,
    comboChance: 0.3,
    hint: "Numbers only",
    speed: 0.075,
    spawnInterval: 2000,
    quota: 12,
    maxAliens: 5,
    bossSpeed: 0.02,
    bossTokens: DIGITS,
  },
  {
    id: 26,
    name: "SYMBOLS",
    focus: "Symbols like ! @ # $ % & * ? — most need SHIFT",
    intro: "Symbols live on the number row and need SHIFT (other hand's pinky). The keyboard guide lights up SHIFT for you.",
    newKeys: SYMBOL_KEYS,
    pool: SYMBOL_KEYS,
    hint: "Symbols only — watch the SHIFT key",
    speed: 0.07,
    spawnInterval: 2200,
    quota: 12,
    maxAliens: 5,
    bossSpeed: 0.02,
    bossTokens: ["!", "@", "#", "$", "%", "&", "*", "?"],
  },
  {
    id: 27,
    name: "EVERYTHING",
    focus: "Letters, numbers and symbols all mixed",
    intro: HOME_REMINDER + " Letters, numbers and symbols can all appear now.",
    newKeys: [],
    newWeight: 0,
    pool: EVERYTHING,
    hint: "Letters, numbers and symbols",
    speed: 0.085,
    spawnInterval: 1800,
    quota: 12,
    maxAliens: 5,
    bossSpeed: 0.022,
    bossTokens: ["a", "7", "#", "k", "2", "@", "z", "9"],
  },
  {
    id: 28,
    name: "EVERYTHING PAIRS",
    focus: "Pairs of letters, numbers and symbols",
    intro: HOME_REMINDER + " Two characters at a time — a letter and a number, a symbol and a letter, anything goes.",
    newKeys: [],
    newWeight: 0,
    comboChance: 0.65,
    pool: EVERYTHING,
    hint: "Mixed pairs",
    speed: 0.085,
    spawnInterval: 1900,
    quota: 12,
    maxAliens: 5,
    bossSpeed: 0.022,
    bossTokens: ["a1", "#k", "2@", "z9", "q!", "m5"],
  },
  {
    id: 29,
    name: "CRAZY",
    focus: "Five-character codes with letters, CAPITALS, numbers and symbols",
    intro: "This is it: five characters at a time, any mix of letters, capitals, numbers and symbols. Case matters. Good luck, pilot!",
    newKeys: [],
    newWeight: 0,
    comboChance: 1,
    comboLen: 5,
    capsChance: 0.35,
    caseSensitive: true,
    pool: EVERYTHING,
    hint: "Type the whole code exactly",
    speed: 0.06,
    spawnInterval: 3200,
    quota: 10,
    maxAliens: 4,
    bossSpeed: 0.016,
    bossTokens: ["Ab3#x", "Q9!zT", "m@4Kp", "7$Rw2", "Zx!9A"],
  },
].map(tuneMultiChar);

export const MISSILE_BATCH = 4;
export const MISSILE_BATCH_PAUSE = 4000;
function tuneMultiChar(lv) {
  if (!isMultiChar(lv)) return lv;
  return {
    ...lv,
    speed: +(lv.speed * MULTI_CHAR_SLOWDOWN).toFixed(4),
    bossSpeed: +(lv.bossSpeed * MULTI_CHAR_SLOWDOWN).toFixed(4),
    missileBatchPause: MULTI_CHAR_BATCH_PAUSE,
  };
}

export const BOSSES = [
  { key: "invader", name: "THE INVADER", color: "#a855f7", pattern: "ring", missiles: 12,
    attack: "fires a ring of curving missiles all around itself" },
  { key: "squid", name: "THE SQUID", color: "#00f0ff", pattern: "rain", missiles: 12,
    attack: "rains missiles straight down in a sweep from left to right" },
  { key: "crab", name: "THE CRAB", color: "#ff6a00", pattern: "spray", missiles: 12,
    attack: "flings fast missiles out of its left and right claws" },
  { key: "mothership", name: "THE MOTHERSHIP", color: "#ff007f", pattern: "spiral", missiles: 12,
    attack: "glides side to side and spins out a spiral of missiles — its label moves too!" },
];

LEVELS.forEach((lv) => {
  lv.quota = Math.round(lv.quota * 1.5);
  if (lv.pool && lv.newWeight <= 0.5) lv.guideKeys = lv.pool;
  lv.boss = BOSSES[(lv.id - 1) % BOSSES.length];
});

export const RAINBOW_CHANCE = 0.15;
export const RAINBOW_SPEED = 1.8;
export const RAINBOW_BONUS = 3;

// levels above this are kept in code but hidden from the UI (set to LEVELS.length to show all)
export const MAX_VISIBLE_LEVEL = 24;
export const VISIBLE_LEVELS = LEVELS.filter((lv) => lv.id <= MAX_VISIBLE_LEVEL);

export const LIVES_PER_LEVEL = 5;

export const STAR_THRESHOLDS = [70, 85, 95]; // accuracy % needed for 1, 2, 3 stars (below 70% = 0 stars)
export const starsFor = (accuracy) => STAR_THRESHOLDS.filter((t) => accuracy >= t).length;
